import { useNavigate } from 'react-router-dom'
import { useUser } from '../api'
import { useDetectIdle } from '../hooks'
import { Confirm, useConfirmControls } from '../components'
import { auth } from '../config'

/** @param {import('./WithAutoLogout.types').WithAutoLogoutProps} props */
export const WithAutoLogout = ({ children }) => {
  const { user, logout } = useUser()
  const navigate = useNavigate()

  const { showPrompt, resetTimers, triggerInactivity } = useDetectIdle({
    onInactivity: async () => {
      if (!user) return
      await logout()
      navigate('/login?loggedOut=inactive', { replace: true })
    },
    inactivityTimeoutMs: auth.inactivityLogoutMinutes * 60 * 1000,
    promptTimeoutMs: auth.inactivityLogoutPromptMinutes * 60 * 1000
  })

  const confirmControls = useConfirmControls()

  return (
    <>
      {children}
      <Confirm
        controls={{
          ...confirmControls,
          isOpen: showPrompt
        }}
        onConfirm={resetTimers}
        onCancel={triggerInactivity}
        onOverlayClick={resetTimers}
        title={'Still active?'}
        confirmBtnCopy='Stay Logged In'
        cancelBtnCopy='Logout now'
      >
        <>
          <p>You will be logged out in 1 minute due to inactivity.</p>
          <p> Click "Stay Logged In" to continue your session.</p>
        </>
      </Confirm>
    </>
  )
}
